import { Card, Form, Input, message } from "antd";
import Button from "./button";
import InvitationSentCard from "./invitationSentCard";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Invite from "../../assets/icons/check.svg";
import { inviteMember } from "../../api/invite";
import PhoneInput from "./handlePhoneInput";

const InviteMemberCard = ({ buttonTitle, buttonType }) => {
  const businessId = localStorage.getItem("businessId");
  const [inviteDone, setInviteDone] = useState(false);
  const [payload, setPayload] = useState({
    businessId: businessId,
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
  });
  const navigate = useNavigate();

  const [form] = Form.useForm();

  const onFinish = async () => {
    try {
      form.validateFields();
      const res = await inviteMember(payload);
      if (res) {
        setInviteDone(true);
        if (buttonType === "save") {
          navigate("/main/profile/manage-team");
        }
      }
    } catch (error) {
      message.error(error.response.data.message);
    }
  };

  const handleFormChange = (changedValues, allValues) => {
    setPayload({ ...payload, ...changedValues });
  };
  if (inviteDone) {
    return <InvitationSentCard img={Invite} />;
  }

  return (
    <Card className="xl:w-111.7 xl:h-21.2">
      <Form onFinish={onFinish} form={form} onValuesChange={handleFormChange}>
        <div className="flex flex-col xl:flex-row xl:items-start items-center xl:justify-evenly xl:space-y-4">
          <Form.Item
            name="firstName"
            rules={[{ required: true, message: "First Name is required" }]}
          >
            <Input
              placeholder="First Name"
              className="w-25 h-5.4 mt-2 xl:mt-4 bg-inputFieldGrey focus:bg-white  focus:border-primaryBlue hover:border-primaryBlue"
              autoFocus
            />
          </Form.Item>
          <Form.Item
            name="lastName"
            rules={[{ required: true, message: "Last name is required" }]}
          >
            <Input
              placeholder="Last Name"
              className="w-25 h-5.4 bg-inputFieldGrey focus:bg-white  focus:border-primaryBlue hover:border-primaryBlue"
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Email is required" }]}
          >
            <Input
              placeholder="Email"
              className="xl:w-25 w-19 h-5.4 bg-inputFieldGrey focus:bg-white focus:border-primaryBlue hover:border-primaryBlue"
            />
          </Form.Item>
          <Form.Item
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: "Please Enter Correct Phone Number",
                pattern: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
              },
            ]}
          >
            <PhoneInput />
          </Form.Item>
        </div>
        <div className="flex xl:justify-end justify-center mr-2">
          <Button
            title={buttonTitle}
            className="bg-primaryPurple w-18 mr-1.5 h-3.8"
            htmlType="submit"
          />
        </div>
      </Form>
    </Card>
  );
};
export default InviteMemberCard;
